import { PropsWithChildren, type JSX } from 'react';

interface Props extends PropsWithChildren {
  placeholder?: string;
}

export const NullValueGuard = ({ children, placeholder = '-' }: Props): JSX.Element => <>{children || placeholder}</>;
